/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * @fileoverview An enum to control who can call certain jsaction APIs.
 */

export enum Restriction {
  I_AM_THE_JSACTION_FRAMEWORK,
}
